module.exports = __webpack_public_path__ + "img/shipo-icon-profile-user.a29462ce.svg";